import { Table } from "@//features/Table";
import { Card } from "@heroui/react";
import { type Audit, columns } from "./columns";

// Define the types for the props and data
// Define the props type
type AuditCardProps = {
  id: number | string;
  client: string;
  audit_table_name: string;
};

// Functional component definition using TypeScript
export function AuditCard<filterSchema>({
  id,
  client,
  audit_table_name,
}: AuditCardProps) {
  return (
    <Card className="xl:mx-28">
      <Table<Audit, filterSchema>
        label="Audit"
        table_name="audits"
        client={client}
        columns={columns}
        audit_table_name={audit_table_name}
        audit_id={typeof id === "string" ? id : Number(id)}
        download_button={false}
      />
    </Card>
  );
}
